import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { fetchCustomersRequest } from 'store/actions';
import CustomerTable from './CustomersTable';
import Breadcrumb from 'components/Common/Breadcrumb2';

const CustomerList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const customers = useSelector((state) => state.Customer.customers); // Get customer data from redux
    const loading = useSelector((state) => state.Customer.loading);
    const error = useSelector((state) => state.Customer.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));


    // Dispatch action to fetch customers when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(fetchCustomersRequest());
    }, [dispatch]);

    return (
        <>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3 ">
                    <Breadcrumb title="Customers" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Customers", link: '#' }]} />
                    {permissions?.map(item=>item?.permissionName)?.includes("Add Customers") && <Button 
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" 
                        onClick={() => navigate('/createCustomer',{ state: { from: window.location.pathname } })} 
                    >
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>
                <CustomerTable loading={loading} List={customers?.Data} /> {/* Pass customer data to the CustomerTable component */}
            </div>
        </>
    );
};

export default CustomerList;
